var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 52,
    viewBox: "0 0 36 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3337 10.2192L32.1147 47.8176L17.6452 52L3.21559 47.8235L0 10.2192H35.3337Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6669 48.8031L29.3589 45.4234L32.1098 13.2939H17.6669V48.8031Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4093 22.5181H17.6669V17.906H6.57504L6.68093 19.1433L7.76811 31.8528H17.6669V27.2408H11.8135L11.4093 22.5181Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 34.1588H7.96576L8.58548 41.4003L17.6465 44.023L17.6669 44.0171V39.2187L17.6475 39.224L12.7211 37.8371L12.4062 34.1588Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28748 0H5.53539V2.31562H7.59171V0H9.83973V7.01228H7.59181V4.66416H5.53549V7.01228H3.28757V0H3.28748Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7958 2.32537H10.8168V0H17.0238V2.32537H15.0439V7.01228H12.7959V2.32537H12.7958Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0089 0H20.3528L21.7947 2.46391L23.2351 0H25.5799V7.01228H23.3413V3.53661L21.7947 6.02987H21.756L20.2084 3.53661V7.01228H18.0089V0Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6987 0H28.9473V4.69442H32.1085V7.01228H26.6987V0Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6516 31.8528H23.0985L22.5851 37.8342L17.6516 39.2226V44.0208L26.7198 41.4004L26.7864 40.6212L27.8258 28.4793L27.9337 27.2408H17.6516V31.8528Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6516 22.5068V22.5181H28.3362L28.425 21.4814L28.6265 19.1433L28.7323 17.906H17.6516V22.5068Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.7f04d838973efa2e4a15878f36e4839d.svg";
export { ForwardRef as ReactComponent };